import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import React from 'react';
import { Button, Icon, List, Popup } from '@gravity-ui/uikit';
import ResizeObserver from 'resize-observer-polyfill';
import { SCOPES } from '../../constants';
import { Key } from '../../types';
import { throttle } from '../../utils';
import { block } from '../../utils/cn';
import i18n from './i18n';
var iconChevron = function iconChevron(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      fill: "none",
      d: "m3 6 5 5 5-5"
    })
  }));
};
iconChevron.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
};
import './ScopesList.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var b = block('scopes-list');
var OTHERS_WIDTH = 72;
var OTHERS_ARROW_WIDTH = 12;
export var ScopesList = /*#__PURE__*/function (_React$Component) {
  _inherits(ScopesList, _React$Component);
  var _super = _createSuper(ScopesList);
  function ScopesList() {
    var _this;
    _classCallCheck(this, ScopesList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      openDropdown: false,
      countVisibleElements: _this.props.initialCountVisibleElements || _this.props.scopes.length
    };
    _this.othersBtnRef = /*#__PURE__*/React.createRef();
    _this.listRef = /*#__PURE__*/React.createRef();
    _this.containerRef = /*#__PURE__*/React.createRef();
    _this.throttledHandleResize = _this.props.autofit ? throttle(function () {
      return _this.handleResize();
    }, 200) : null;
    _this.resizeObserver = _this.throttledHandleResize ? new ResizeObserver(_this.throttledHandleResize) : null;
    _this.prepareDropdownItems = function (items) {
      return items.filter(function (item) {
        return item !== _this.props.selectedScope;
      });
    };
    _this.renderItem = function (item) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var index = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props = _this.props,
        view = _this$props.view,
        renderItem = _this$props.renderItem;
      var isItemActive = params.isItemActive,
        isOthersTitle = params.isOthersTitle,
        isOthers = params.isOthers;
      if (renderItem) {
        if (isOthersTitle || isOthers) {
          return renderItem(item, params);
        } else {
          return /*#__PURE__*/_jsx("div", {
            className: b('scope', {
              selected: isItemActive
            }),
            onClick: _this.onScopeClick,
            "data-scope": item,
            children: renderItem(item, params, index)
          }, index);
        }
      }
      if (isOthersTitle) {
        return i18n(item);
      }
      if (isOthers) {
        return /*#__PURE__*/_jsx("div", {
          className: b('others-text'),
          role: "menuitem",
          children: i18n(item)
        });
      }
      var isTabs = view === 'tabs';
      var buttonView = 'outlined';
      if (isTabs) {
        buttonView = 'flat';
      } else if (isItemActive) {
        buttonView = 'normal';
      }
      return /*#__PURE__*/_jsx(Button, {
        selected: isItemActive,
        view: buttonView,
        pin: isTabs ? 'brick-brick' : 'round-round',
        onClick: _this.onScopeClick,
        className: b('scope'),
        extraProps: {
          name: item,
          'aria-label': item
        },
        children: i18n(item)
      }, index);
    };
    _this.renderDropdownItem = function (item) {
      return _this.renderItem(item, {
        isOthers: true
      });
    };
    _this.onCloseDropdown = function () {
      _this.setState({
        openDropdown: false
      });
    };
    _this.toggleDropdown = function (event) {
      event.stopPropagation();
      _this.setState(function (state) {
        return {
          openDropdown: !state.openDropdown
        };
      });
    };
    _this.onOthersKeyDown = function (event) {
      var _this$listRef;
      var list = (_this$listRef = _this.listRef) === null || _this$listRef === void 0 ? void 0 : _this$listRef.current;
      if (list && _this.state.openDropdown) {
        if (event.key === Key.ARROW_DOWN || event.key === Key.ARROW_UP || event.key === Key.ENTER) {
          event.stopPropagation();
          list.onKeyDown(event);
        }
      }
    };
    _this.onDropdownItemClick = function (item, _, fromKeyboard) {
      var onScopeClick = _this.props.onScopeClick;
      if (!fromKeyboard) {
        _this.setState({
          openDropdown: false
        });
      }
      if (onScopeClick) {
        onScopeClick(item, {
          fromKeyboard: fromKeyboard,
          fromDropdown: true
        });
      }
    };
    _this.onScopeClick = function (e) {
      var _e$currentTarget, _e$currentTarget2;
      var onScopeClick = _this.props.onScopeClick;
      var item = ((_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.getAttribute('name')) || ((_e$currentTarget2 = e.currentTarget) === null || _e$currentTarget2 === void 0 ? void 0 : _e$currentTarget2.getAttribute('data-scope'));
      if (onScopeClick) {
        onScopeClick(item);
      }
    };
    _this.calcMaxOthersWidth = function (itemsWidths) {
      return Math.max.apply(Math, _toConsumableArray(itemsWidths.concat([OTHERS_WIDTH]))) + OTHERS_ARROW_WIDTH;
    };
    _this.handleResize = function () {
      _this.setState({
        countVisibleElements: _this.props.scopes.length
      }, _this.collapseToOthers);
    };
    return _this;
  }
  _createClass(ScopesList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.initialCountVisibleElements && this.props.autofit) {
        this.collapseToOthers();
      }
      if (this.resizeObserver) {
        this.resizeObserver.observe(this.containerRef.current);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        selectedScope = _this$props2.selectedScope,
        scopes = _this$props2.scopes,
        view = _this$props2.view,
        className = _this$props2.className,
        popupClassName = _this$props2.popupClassName,
        popupContentClassName = _this$props2.popupContentClassName,
        onKeyDown = _this$props2.onKeyDown;
      var countVisibleElements = this.state.countVisibleElements;
      var visibleItems = scopes.slice(0, countVisibleElements);
      var hiddenItems = scopes.slice(countVisibleElements);
      var isSelectedFromDropdown = hiddenItems.includes(selectedScope);
      var preparedHiddenItems = this.prepareDropdownItems(hiddenItems);
      var isTabs = view === 'tabs';
      var buttonView = 'outlined';
      if (isTabs) {
        buttonView = 'flat';
      } else if (isSelectedFromDropdown) {
        buttonView = 'normal';
      }
      return /*#__PURE__*/_jsxs("div", {
        onKeyDown: onKeyDown,
        className: b({
          view: view
        }, className),
        ref: this.containerRef,
        role: "menu",
        children: [visibleItems.map(function (item, index) {
          return _this2.renderItem(item, {
            isItemActive: selectedScope === item
          }, index);
        }), scopes.length > countVisibleElements && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            onKeyDown: this.onOthersKeyDown,
            className: b('others'),
            role: "menuitem",
            children: /*#__PURE__*/_jsxs(Button, {
              selected: isSelectedFromDropdown,
              view: buttonView,
              pin: isTabs ? 'brick-brick' : 'round-round',
              ref: this.othersBtnRef,
              onClick: this.toggleDropdown,
              className: b('scope-others'),
              extraProps: {
                name: selectedScope,
                'aria-label': 'others',
                'aria-haspopup': 'true'
              },
              children: [isSelectedFromDropdown ? this.renderItem(selectedScope, {
                isItemActive: true,
                isOthersTitle: true
              }) : i18n('others'), /*#__PURE__*/_jsx(Icon, {
                data: iconChevron,
                size: 16
              })]
            })
          }), /*#__PURE__*/_jsx(Popup, {
            open: this.state.openDropdown,
            anchorRef: this.othersBtnRef,
            className: b(null, popupClassName),
            contentClassName: b(null, popupContentClassName),
            onClose: this.onCloseDropdown,
            children: /*#__PURE__*/_jsx(List, {
              filterable: false,
              items: preparedHiddenItems,
              renderItem: this.renderDropdownItem,
              itemClassName: b('others-item'),
              onItemClick: this.onDropdownItemClick,
              virtualized: false,
              ref: this.listRef
            })
          })]
        })]
      });
    }
  }, {
    key: "collapseToOthers",
    value: function collapseToOthers() {
      if (!this.containerRef.current) {
        return;
      }
      var items = Array.from(this.containerRef.current.querySelectorAll(".".concat(b('scope'))));
      var availableWidth = this.containerRef.current.offsetWidth;
      var itemsWidths = items.map(function (elem) {
        return elem.offsetWidth;
      });
      var gap = parseInt(getComputedStyle(this.containerRef.current).gap, 10);
      var count = 0;
      var currentWidth = 0;
      for (var i = 0; i < items.length; i++) {
        var w = items[i].offsetWidth + gap;
        if (currentWidth + w <= availableWidth) {
          currentWidth += w;
          count++;
        } else {
          break;
        }
      }
      if (count && count < items.length) {
        var maxRestW = this.calcMaxOthersWidth(itemsWidths.slice(count));
        while (currentWidth + maxRestW > availableWidth) {
          var _w = items[count - 1].offsetWidth + gap;
          currentWidth -= _w;
          count--;
          maxRestW = this.calcMaxOthersWidth(itemsWidths.slice(count));
        }
      }
      this.setState({
        countVisibleElements: count
      });
    }
  }]);
  return ScopesList;
}(React.Component);
ScopesList.defaultProps = {
  scopes: SCOPES,
  selectedScope: 'all',
  view: 'buttons',
  autofit: true,
  onScopeClick: function onScopeClick() {
    return true;
  }
};
// #sourceMappingURL=ScopesList.js.map